import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import NOB from './constants/language-strings';
import configureStore from './store';
import { currentVersion } from './version';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/index.scss';
import '@purpurds/tokens/index.css';
import '@purpurds/purpur/styles';
import { GlobalStyle } from 'theme/global-styles/global-styles';
import App from './app/App';
import { BrowserRouter } from 'react-router-dom';
const store = configureStore({ NOB });
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0,
            cacheTime: 0,
        },
    },
});
const redirectUrl = window.location.origin + '/sso';
const AUTH_URI = process.env.AUTH_URI;
const CLIENT_ID = process.env.CLIENT_ID;
const oidcConfig = {
    authority: AUTH_URI,
    client_id: CLIENT_ID,
    redirect_uri: redirectUrl,
    post_logout_redirect_uri: redirectUrl,
    onSigninCallback: () => window.history.replaceState({}, document.title, window.location.pathname),
    scope: 'openid profile',
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    response_type: 'code',
};
const loadOidcMetadata = async () => {
    const response = await fetch(`${AUTH_URI}/.well-known/openid-configuration`);
    const oidcMetadata = await response.json();
    return Object.assign(Object.assign({}, oidcMetadata), { end_session_endpoint: `${AUTH_URI}/idp/startSLO.ping` });
};
const container = document.getElementById('app');
const root = createRoot(container);
// If the download fails, render without metadata so the library falls back to metadataUrl
void loadOidcMetadata()
    .catch(e => {
    //eslint-disable-next-line no-console
    console.error('Failed to load OIDC metadata:', e);
    return {
        issuer: AUTH_URI,
        authorization_endpoint: `${AUTH_URI}/as/authorization.oauth2`,
        token_endpoint: `${AUTH_URI}/as/token.oauth2`,
        userinfo_endpoint: `${AUTH_URI}/idp/userinfo.openid`,
        revocation_endpoint: `${AUTH_URI}/as/revoke_token.oauth2`,
        jwks_uri: `${AUTH_URI}/pf/JWKS`,
        end_session_endpoint: `${AUTH_URI}/idp/startSLO.ping`,
    };
})
    .then(metadata => root.render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(AuthProvider, Object.assign({}, oidcConfig, { metadata: metadata, children: _jsxs(Provider, { store: store, children: [_jsx(GlobalStyle, {}), _jsx(BrowserRouter, { children: _jsx(App, {}) })] }) })) })));
document.getElementById('version').innerText = currentVersion;
